module.exports = "<div>\r\n\t<input type=\"checkbox\"\r\n\t\t   id=\"checkbox_{{ id }}\"\r\n\t\t   class=\"regular-checkbox\"\r\n\t\t   [checked]=\"checked ? 'checked' : ''\"\r\n\t\t   (click)='onInputClicked(id)'\r\n\t\t   [disabled]=\" disabled ? 'disabled' : '' \"\r\n\t/>\r\n\t<label for=\"checkbox_{{ id }}\"></label>\r\n</div>\r\n<div class=\"ansyn-checkbox-text\">\r\n\t<span>{{text}}</span>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/user/projects/ansyn/src/app/packages/core/components/ansyn-checkbox/ansyn-checkbox.component.html
// module id = ../../../../../src/app/packages/core/components/ansyn-checkbox/ansyn-checkbox.component.html
// module chunks = main